/* Sweden: Hard Kombucha is not sold online. Henry, 2026-09-15: "Then we only ship non-alco to Sweden. If sweden wants
   to order, can we add for Hard Kombucha to write an email to our support?"

   Who counts as Swedish - either attribute on <html> is enough:
   - data-rk-country: Shopify's localization country. Shopify sets it from the visitor's IP on the first page (the
     response carries Set-Cookie localization=XX - a real browser from NL got NL on 2026-09-15; plain curl requests
     get the LV default) or from the country selector. A visitor who picked another country keeps that choice.
   - data-rk-geo: the visitor's location, set here as a backup for that case. Cloudflare's /cdn-cgi/trace answers first (the site runs through
     Henry's Cloudflare, the same source snippets/geo-redirect.liquid uses). When it says Sweden, Shopify's own
     geolocation has to agree before Hard is taken away: Latvia is the main market and Baltic carriers owned by Swedish
     groups (Tele2, Telia) can hold Swedish-registered address ranges. Cached in localStorage for 6 hours; the inline
     script in layout/theme.liquid restores it before first paint.

   The inline rules in layout/theme.liquid show and hide ([data-rk-hard-buy="1"], .rk-hardse[hidden]). This script sets
   data-rk-geo and keeps a cart's checkout button locked while that cart holds Hard ([data-rk-hard-cart]). The theme
   cannot see the delivery address typed at checkout - that last line of defence belongs in Shopify admin. */
(function () {
  if (window.rkCheckoutBlocked) return;
  var RESTRICTED = ['SE'];
  var KEY = 'rk.geo', TTL = 6 * 36e5;
  var root = document.documentElement;

  function restricted() {
    return RESTRICTED.indexOf(root.getAttribute('data-rk-country')) > -1 ||
           RESTRICTED.indexOf(root.getAttribute('data-rk-geo')) > -1;
  }
  // Also read by assets/rk-terms-gate.js, which would otherwise unlock the button as soon as the terms box is ticked.
  window.rkCheckoutBlocked = function (button) {
    return !!(button && button.hasAttribute('data-rk-hard-cart') && restricted());
  };

  function lockAll() {
    if (!restricted()) return;
    document.querySelectorAll('[data-rk-hard-cart]').forEach(function (b) {
      b.disabled = true;
      b.setAttribute('aria-disabled', 'true');
    });
  }
  function refresh() {
    lockAll();
    if (typeof window.rkTermsGateInit === 'function') window.rkTermsGateInit();
  }

  // Parcely's cartV2.js toggles `disabled` on checkout buttons by itself, so refuse the click and the submit as well.
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-rk-hard-cart]');
    if (b && window.rkCheckoutBlocked(b)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('submit', function (e) {
    if (e.submitter && window.rkCheckoutBlocked(e.submitter)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  function cached() {
    try { var g = JSON.parse(localStorage.getItem(KEY) || 'null'); return g && Date.now() - g.t < TTL ? g.loc : null; }
    catch (e) { return null; }
  }
  function setGeo(loc) {
    if (!/^[A-Z]{2}$/.test(loc || '')) return;
    try { localStorage.setItem(KEY, JSON.stringify({ loc: loc, t: Date.now() })); } catch (e) { /* private mode */ }
    root.setAttribute('data-rk-geo', loc);
    refresh();
  }
  function text(url) {
    return fetch(url, { cache: 'no-store', credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; });
  }
  function detect() {
    return text('/cdn-cgi/trace').then(function (t) {
      var loc = (/^loc=([A-Z]{2})$/m.exec(t) || [])[1];
      if (!loc || RESTRICTED.indexOf(loc) === -1) return loc;
      return text('/browsing_context_suggestions.json')
        .then(function (s) {
          var c = ((JSON.parse(s).detected_values || {}).country || {}).handle;
          return c || loc; // the two disagree: Shopify's answer wins; Shopify silent: keep Cloudflare's
        })
        .catch(function () { return loc; });
    });
  }
  var known = cached();
  if (known) {
    if (root.getAttribute('data-rk-geo') !== known) root.setAttribute('data-rk-geo', known);
  } else {
    detect().then(setGeo).catch(function () { /* no Cloudflare in front (myshopify preview): Shopify's country still applies */ });
  }

  function start() {
    refresh();
    // Dawn's cart PAGE re-renders only the item list, not the footer that holds the notice and the locked button:
    // reload so they follow the cart once the Hard line is removed.
    if (/^\/([a-z]{2}(-[a-z]{2})?\/)?cart\/?$/i.test(location.pathname) &&
        typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        if (restricted() && document.querySelector('#checkout[data-rk-hard-cart]')) location.reload();
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  // Dawn replaces the drawer markup on every change; lock the new button when it arrives.
  var pending = 0;
  new MutationObserver(function () { if (!pending) pending = setTimeout(function () { pending = 0; lockAll(); }, 50); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
